import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/examination/examinationpaper',
  '/statistics/SportsSchoolQuestionnaire1'] // no redirect whitelist
router.beforeEach(async (to, from, next) => {
  console.log(to.fullPath);
  // const route=window.sessionStorage.setItem('route', 'to.fullPath')
  const roleId = window.localStorage.getItem('roleId')
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else if (to.meta.role && to.meta.role.indexOf(roleId % 14) === -1) {
      router.back()
      // next({ path: '/404' })
      next()
      NProgress.done()
    } else {
      next()
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      store.dispatch('user/logout')
      next(`/login`)
      NProgress.done()
    }
  }
})


router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
